import React from 'react'

import { createFilterContext } from './context'
import type { JobOfferFilter } from '../../../api/job-offers/types'
import type { EventFilters } from '../../../api/events/types'
import type { NotificationFilters } from '../../../api/notifications/types'
import type { CompanyFilter } from '../../../api/companies/types'
import { VideoFilter } from '../../../ui/containers/content/videos/types'
import { DocumentFilter } from '../../../ui/containers/content/documents/types'

const { FilterProvider: JobOfferFilterProvider, useFilter: useJobOfferFilter } = createFilterContext<JobOfferFilter>()
const { FilterProvider: EventFilterProvider, useFilter: useEventFilter } = createFilterContext<EventFilters>()
const { FilterProvider: NotificationFilterProvider, useFilter: useNotificationFilter } = createFilterContext<NotificationFilters>()
const { FilterProvider: CompanyFilterProvider, useFilter: useCompanyFilter } = createFilterContext<CompanyFilter>()
const { FilterProvider: ContentFilterProvider, useFilter: useContentFilter } = createFilterContext<(VideoFilter | DocumentFilter) & { sortBy?: string }>()

export {
  useJobOfferFilter,
  useEventFilter,
  useNotificationFilter,
  useCompanyFilter,
  useContentFilter,
}

const FilterProviders:React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <JobOfferFilterProvider>
      <EventFilterProvider>
        <NotificationFilterProvider>
          <CompanyFilterProvider>
            <ContentFilterProvider>
              {children}
            </ContentFilterProvider>
          </CompanyFilterProvider>
        </NotificationFilterProvider>
      </EventFilterProvider>
    </JobOfferFilterProvider>
  )
}

FilterProviders.displayName = 'FilterProviders'

export default FilterProviders
